import { useTheme } from '@mui/material';

export const EnvelopesIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="270"
            height="113"
            viewBox="0 0 270 113"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M171.588 42.7103L172.175 41.9011L171.588 42.7102L131.588 13.6626C131.237 13.4082 130.763 13.4082 130.412 13.6626L90.4124 42.7102C90.1533 42.8984 90 43.1992 90 43.5194V49.5001H172V43.5194C172 43.1992 171.847 42.8984 171.588 42.7103Z"
                fill={primaryBackground}
                stroke={primaryStroke}
                strokeWidth="2"
            />
            <rect x="99.5" y="5.00006" width="63" height="63" rx="2" fill="#FBFBFB" />
            <rect x="108" y="20.0001" width="46" height="2" rx="1" fill="#E4E4E4" />
            <rect x="108" y="28.0001" width="46" height="2" rx="1" fill="#E4E4E4" />
            <rect x="108" y="36.0001" width="46" height="2" rx="1" fill="#E4E4E4" />
            <rect x="108" y="44.0001" width="46" height="2" rx="1" fill="#E4E4E4" />
            <path
                d="M90 90.0001V45.0001L129.846 61.6026C130.585 61.9103 131.415 61.9103 132.154 61.6026L172 45.0001V90.0001C172 92.7615 169.761 95.0001 167 95.0001H95C92.2386 95.0001 90 92.7615 90 90.0001Z"
                fill="white"
                stroke={primaryStroke}
                strokeWidth="2"
            />
            <path
                d="M159 82.0001L169.5 92.5001M103 82.0001L92.5 92.5001"
                stroke={primaryStroke}
                strokeWidth="2"
                strokeLinecap="round"
            />
            <rect
                x="212.932"
                y="6.45221"
                width="23"
                height="16"
                rx="1.5"
                transform="rotate(-13.7039 212.932 6.45221)"
                fill="white"
                stroke="#D7D7D7"
            />
            <path
                d="M225.143 11.1742L213.247 7.63866C213.206 6.92995 213.675 6.27105 214.389 6.09686L233.82 1.35877C234.534 1.18458 235.254 1.55364 235.544 2.20158L226.611 10.8161C226.222 11.1914 225.661 11.3282 225.143 11.1742Z"
                fill="white"
                stroke="#D7D7D7"
            />
            <path
                d="M234.838 13.9767L238.464 16.1806M219.294 17.7672L217.09 21.3925"
                stroke="#D7D7D7"
                strokeLinecap="round"
            />
            <rect
                x="37.6042"
                y="51.0531"
                width="23"
                height="16"
                rx="1.5"
                transform="rotate(-13.7039 37.6042 51.0531)"
                fill="white"
                stroke="#D9D9D9"
            />
            <path
                d="M49.8147 55.775L37.919 52.2395C37.8782 51.5308 38.3472 50.8719 39.0615 50.6977L58.4922 45.9596C59.2065 45.7854 59.9262 46.1545 60.2162 46.8024L51.2832 55.4169C50.894 55.7923 50.333 55.9291 49.8147 55.775Z"
                fill="white"
                stroke="#D9D9D9"
            />
            <path
                d="M59.5104 58.5776L63.1357 60.7815M43.9659 62.3681L41.762 65.9934"
                stroke="#D9D9D9"
                strokeLinecap="round"
            />
            <rect
                x="201.177"
                y="58.2757"
                width="11.9236"
                height="8.30005"
                rx="1.75"
                transform="rotate(6.23443 201.177 58.2757)"
                fill="white"
                stroke="#D7D7D7"
                strokeWidth="0.5"
            />
            <path
                d="M205.835 62.4111L201.118 58.9218C201.223 58.5624 201.573 58.3189 201.958 58.361L212.249 59.4853C212.634 59.5273 212.924 59.8407 212.948 60.2141L207.589 62.6026C207.012 62.8594 206.343 62.7863 205.835 62.4111Z"
                fill="white"
                stroke="#D7D7D7"
                strokeWidth="0.5"
            />
            <path
                d="M210.516 65.814L211.892 67.5264M202.283 64.9145L200.571 66.2896"
                stroke="#D7D7D7"
                strokeWidth="0.5"
                strokeLinecap="round"
            />
            <rect
                x="57.1459"
                y="13.5605"
                width="11.9236"
                height="7.72717"
                rx="1.75"
                transform="rotate(6.23443 57.1459 13.5605)"
                fill="white"
                stroke="#D9D9D9"
                strokeWidth="0.5"
            />
            <path
                d="M61.8742 17.4609L57.097 14.1356C57.1978 13.8156 57.5134 13.6006 57.8596 13.6384L68.2854 14.7774C68.6316 14.8152 68.8933 15.0932 68.9226 15.4274L63.5401 17.6428C62.99 17.8693 62.3625 17.8007 61.8742 17.4609Z"
                fill="white"
                stroke="#D9D9D9"
                strokeWidth="0.5"
            />
            <path
                d="M66.533 20.6632L67.9191 22.2752M58.2996 19.7638L56.5982 21.0384"
                stroke="#D9D9D9"
                strokeWidth="0.5"
                strokeLinecap="round"
            />
            <rect
                x="249.049"
                y="33.1419"
                width="11.9236"
                height="7.72717"
                rx="1.75"
                transform="rotate(35.8212 249.049 33.1419)"
                fill="white"
                stroke="#D7D7D7"
                strokeWidth="0.5"
            />
            <path
                d="M251.235 38.8683L248.722 33.6179C248.968 33.3894 249.349 33.3582 249.631 33.5621L258.135 39.7001C258.417 39.904 258.508 40.275 258.368 40.5801L252.594 39.849C252.003 39.7743 251.492 39.4049 251.235 38.8683Z"
                fill="white"
                stroke="#D7D7D7"
                strokeWidth="0.5"
            />
            <path
                d="M253.705 43.9534L254.115 46.0395M246.989 39.1061L244.881 39.3744"
                stroke="#D7D7D7"
                strokeWidth="0.5"
                strokeLinecap="round"
            />
            <rect
                x="5.17694"
                y="51.2757"
                width="11.9236"
                height="8.30005"
                rx="1.75"
                transform="rotate(6.23443 5.17694 51.2757)"
                fill="white"
                stroke="#AEAEAE"
                strokeWidth="0.5"
            />
            <path
                d="M9.83542 55.4111L5.11828 51.9218C5.22261 51.5624 5.57279 51.3189 5.9576 51.361L16.2494 52.4853C16.6342 52.5273 16.9235 52.8407 16.9478 53.2141L11.5885 55.6026C11.0124 55.8594 10.3426 55.7863 9.83542 55.4111Z"
                fill="white"
                stroke="#AEAEAE"
                strokeWidth="0.5"
            />
            <path
                d="M14.5164 58.814L15.8916 60.5264M6.28302 57.9145L4.57061 59.2896"
                stroke="#AEAEAE"
                strokeWidth="0.5"
                strokeLinecap="round"
            />
            <rect
                x="244.009"
                y="78.5473"
                width="24.3927"
                height="16.9865"
                rx="1.5"
                transform="rotate(-1.86126 244.009 78.5473)"
                fill="white"
                stroke="#D7D7D7"
            />
            <path
                d="M255.703 86.1741L244.061 79.8805C244.119 79.1278 244.736 78.5237 245.508 78.4986L266.89 77.8038C267.661 77.7787 268.316 78.3415 268.423 79.0888L257.214 86.125C256.756 86.4124 256.179 86.4312 255.703 86.1741Z"
                fill="white"
                stroke="#D7D7D7"
            />
            <path
                d="M265.089 91.1237L268.365 94.193M248.169 91.6735L245.1 94.949"
                stroke="#D7D7D7"
                strokeLinecap="round"
            />
            <rect
                x="12.516"
                y="95.3083"
                width="24.3927"
                height="16.9865"
                rx="1.5"
                transform="rotate(-1.86126 12.516 95.3083)"
                fill="white"
                stroke="#D9D9D9"
            />
            <path
                d="M24.2104 102.935L12.5684 96.6414C12.6265 95.8888 13.2432 95.2846 14.0152 95.2595L35.3966 94.5647C36.1686 94.5396 36.8232 95.1024 36.9301 95.8498L25.7212 102.886C25.2633 103.173 24.686 103.192 24.2104 102.935Z"
                fill="white"
                stroke="#D9D9D9"
            />
            <path
                d="M33.5961 107.885L36.8716 110.954M16.6766 108.434L13.6072 111.71"
                stroke="#D9D9D9"
                strokeLinecap="round"
            />
            <rect
                x="196.32"
                y="101.15"
                width="14.3369"
                height="10.0095"
                rx="1.75"
                transform="rotate(-19.6907 196.32 101.15)"
                fill="white"
                stroke="#AEAEAE"
                strokeWidth="0.5"
            />
            <path
                d="M203.758 103.278L196.614 101.946C196.516 101.472 196.78 100.986 197.248 100.818L208.889 96.652C209.358 96.4842 209.87 96.6929 210.095 97.1216L205.419 102.684C205.013 103.167 204.378 103.394 203.758 103.278Z"
                fill="white"
                stroke="#AEAEAE"
                strokeWidth="0.5"
            />
            <path
                d="M210.349 104.4L212.72 105.521M201.036 107.733L199.915 110.104"
                stroke="#AEAEAE"
                strokeWidth="0.5"
                strokeLinecap="round"
            />
            <rect
                x="57.3196"
                y="84.3511"
                width="11.9648"
                height="8.32923"
                rx="1.75"
                transform="rotate(-19.6907 57.3196 84.3511)"
                fill="white"
                stroke="#D9D9D9"
                strokeWidth="0.5"
            />
            <path
                d="M63.3419 86.0413L57.5504 84.961C57.4866 84.5904 57.696 84.2164 58.0622 84.0853L67.8422 80.5854C68.2084 80.4543 68.6076 80.6105 68.7934 80.9375L65.0023 85.4471C64.5964 85.9299 63.962 86.1569 63.3419 86.0413Z"
                fill="white"
                stroke="#D9D9D9"
                strokeWidth="0.5"
            />
            <path
                d="M69.0549 87.057L71.0468 87.999M61.2309 89.8569L60.2889 91.8489"
                stroke="#D9D9D9"
                strokeWidth="0.5"
                strokeLinecap="round"
            />
            <rect
                x="0.859937"
                y="17.3249"
                width="17.9944"
                height="12.4544"
                rx="1.5"
                transform="rotate(-19.6907 0.859937 17.3249)"
                fill="white"
                stroke="#D9D9D9"
            />
            <path
                d="M10.5074 19.8236L1.16599 18.0812C1.12031 17.5999 1.40341 17.1304 1.87949 16.9601L16.7826 11.6267C17.2587 11.4563 17.7753 11.6395 18.0454 12.0405L11.9306 19.3143C11.5827 19.7281 11.0389 19.9227 10.5074 19.8236Z"
                fill="white"
                stroke="#D9D9D9"
            />
            <path
                d="M18.5906 21.3763L21.6261 22.8118M6.66809 25.643L5.23262 28.6785"
                stroke="#D9D9D9"
                strokeLinecap="round"
            />
        </svg>
    );
};
